// **************************
// *** notificacoes.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 09/06/24
// **************************


import { useEffect, useState } from "react";
import apiaxios from "../../../../Services/apiaxios.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner

import Menu   from "../../components/Menu/menu.jsx";
import Footer from "../../components/Footer/footer.jsx";

import './notificacoes.css';


function Notificacoes (){
    const [idUsuario, setIdUsuario] = useState(() => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return decryptedUser.id_usuario || 0;
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return 0;
            }
        }
        return 0;
    });

    const [nenhumaNotificacaoEncontrada, setNenhumaNotificacaoEncontrada] = useState(false);

    const [dados, setDados] = useState([]);
    const [loading, setLoading] = useState(false); // loading na tela
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);

                if (decryptedUser) {
                    setIdUsuario(decryptedUser.id_usuario);
                }
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            }
        }
    }, []); // Dependência vazia para rodar uma vez após a montagem do componente

    useEffect(() =>{
        fetchDados(pagina);
    }, [pagina]); // react reclamou do idUsuario, foi removido 12/6/24w
    // }, [idUsuario, pagina]);

        // ****** dados para pegar notificao inicial (como está no delphi [mobile/desktop]):
        // ****** pagina: 1
        // ****** tamanho_pagina: 15
        // ****** id_usuario_global: idUsuario
        // ****** tipo_app: 0
        // ****** ind_clear: true (somente para paginação no front-end - não vai para o backend)

        // ****** dados de retorno: jsonarray contendo:
        // [
        //     {"ID_NOTIFICATION":868,
                    // "ID_USUARIO":70,
                    // "NT_TIPO":91,
                    // "ID_RESERVA":283,
                    // "NT_DATA":"04\/06\/2024 11:28:56",
                    // "NT_READ":0,
                    // "NT_DEL":0,
                    // "NT_DESCRIPTION":"FALTA 1 DIA PARA SEU COMPROMISSO AGENDADO"},
        //     {"ID_NOTIFICATION":865,"ID_USUARIO":70,"NT_TIPO":91,"ID_RESERVA":282,"NT_DATA":"04\/06\/2024 11:19:47","NT_READ":0,"NT_DEL":0,"NT_DESCRIPTION":"FALTA 1 DIA PARA SEU COMPROMISSO AGENDADO"}
        // ]
    const fetchDados = (pagina) => {
        setLoading(true);
        const url = `/Notificacao/Recebe?id_usuario=${idUsuario}&tipoApp=0&pagina=${pagina}&tamanho_pagina=15`;

        apiaxios.get(url)
        .then((response) => {
            setLoading(false);
            if (response.data.retorno) {
                // Verifica se a resposta contém uma mensagem de erro
                alert('Erro ao listar notificações: ' + response.data.retorno);
                
            } else {
                // Não há mensagem de erro, então os dados foram retornados com sucesso
                if (response.data.length === 0) {
                    setNenhumaNotificacaoEncontrada(true);
                    setHasMore(false);
                } else {
                    setNenhumaNotificacaoEncontrada(false);
                    setDados(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < 15) {
                        setHasMore(false);
                    }
                }
            }
            }).catch(error => {
                // Trate o erro
                setLoading(false);
                alert('Erro ao carregar notificações :' + error);
            }).finally(
                setLoading(false)
            );
    };

    const handleExcluir = (id_notificacao) => {
        Swal.fire({
            title: "Confirma Exclusão?",
            text: `Esta notificação ${id_notificacao} será excluída definitivamente!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const url = `/Notificacao/Del`;
    
                apiaxios.delete(url, {
                    data: { id_notificacao: id_notificacao }
                })
                .then((response) => {
                    setLoading(false);
                    if (response.status !== 200) {
                        const data = response.data.retorno;
                        throw new Error(data.retorno);
                    }
    
                    if (response.data.retorno) {
                        Swal.fire({
                            title: "Exclusão de notificação",
                            text: `A notificação ${id_notificacao} foi excluída definitivamente!`,
                            icon: "success"
                        });
                        // Após a exclusão, fazemos uma nova consulta à API para atualizar a lista de notificações
                        // Atualiza localmente a lista de notificações
                        setDados(prevDados => {
                            const novosDados = prevDados.filter(dado => dado.ID_NOTIFICATION !== id_notificacao);
                            return novosDados;
                        });
                        // Após atualizar localmente, faz uma nova consulta à API para garantir a consistência
                        atualizarListaNotificacoes();
                    } else {
                        console.error('Resposta inesperada do servidor', response.data);
                    }
                }).catch(error => {
                    setLoading(false);
                    alert('Erro ao excluir notificação :' + error);
                });
            }
        });
    };
    
    const atualizarListaNotificacoes = () => {
        const url = `/Notificacao/Recebe?id_usuario=${idUsuario}&tipoApp=0&pagina=${pagina}&tamanho_pagina=15`;

        apiaxios.get(url)
            .then((response) => {
                if (response.status === 200) {
                    setDados(response.data);
                    setNenhumaNotificacaoEncontrada(response.data.length === 0);
                    setHasMore(response.data.length >= 15);
                } else {
                    throw new Error("Erro ao carregar notificações");
                }
            })
            .catch((error) => {
                console.error("Erro ao carregar notificações:", error);
                setNenhumaNotificacaoEncontrada(true);
                setHasMore(false);
            });
    };
    
    const handleChangeStatus = (id_notificacao, NT_READ) => {
        if (NT_READ === 0) return;  // Se já lido, não faz nada // INVERTIDO (0=não lido / 1=lido)
            Swal.fire({
                title: "Confirma alteração?",
                text: `Esta notificação ${id_notificacao} será marcada como não lida!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, confirmar!",
                cancelButtonText: "Não"
              }).then((result) => {
                if (result.isConfirmed) { // isConfirmed=true clicou no botão sim.
                    setLoading(true);
                    const url = `/Notificacao/noRead?id_notificacao=${id_notificacao}`;
                    apiaxios.get(url)
                    .then((response) => {
                        setLoading(false);
                        if (response.status !== 200) {
                            const data = response.data.retorno;
                            throw new Error(data.retorno);
                        }
            
                        if (response.data.retorno) {
                            // Verifica se a resposta contém uma mensagem de erro
                            Swal.fire({
                                title: "Status Alterado",
                                text: `Esta notificação ${id_notificacao} foi marcada como não lida!`,
                                icon: "success"
                              });
                            // Atualizar o estado local para marcar a notificação como não lida
                            setDados(prevDados => prevDados.map(dado => 
                                dado.ID_NOTIFICATION === id_notificacao ? { ...dado, NT_READ: 0 } : dado
                            ));
                                        
                        } else {
                            // Não há mensagem de erro, então os dados foram retornados com sucesso
                            if (response.data.length === 0) {
                                setNenhumaNotificacaoEncontrada(true);
                                setHasMore(false);
                            } else {
                                setNenhumaNotificacaoEncontrada(false);
                                setDados(prevDados => [...prevDados, ...response.data]);
                                if (response.data.length < 15) {
                                    setHasMore(false);
                                }
                            }
                        }
                        }).catch(error => {
                            // Trate o erro
                            setLoading(false);
                            alert('Erro ao alterar status da notificação :' + error);
                        });
                }
              });
    };

    const handleInfo = (id_notificacao, data, id_reserva, tp_notificacao, descricao) => {
        Swal.fire({
            title: "Notificação",
            text: `id/notificação: ${id_notificacao} | Data/Hora: ${data} | id/Reserva: ${id_reserva} |
                   Tipo da Notificação: ${tp_notificacao} | Descrição: ${descricao}`, 
            icon: "info",
            // showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK"
            // cancelButtonText: "voltar"
          }).then((result) => {
            if (result.isConfirmed) { // isConfirmed=true clicou no botão sim.
                setLoading(true);
                const url = `/Notificacao/Read?id_notificacao=${id_notificacao}`;
                apiaxios.get(url)
                .then((response) => {
                    setLoading(false);
                    if (response.status !== 200) {
                        const data = response.data.retorno;
                        throw new Error(data.retorno);
                    }
        
                    if (response.data.retorno) {
                        // Verifica se a resposta contém uma mensagem de erro
                        Swal.fire({
                            title: "Status Alterado",
                            text: `Esta notificação ${id_notificacao} foi marcada como lida!`,
                            icon: "success"
                          });
                        // Atualizar o estado local para marcar a notificação como lida
                        setDados(prevDados => prevDados.map(dado => 
                            dado.ID_NOTIFICATION === id_notificacao ? { ...dado, NT_READ: 1 } : dado
                        ));                                    
                    } else {
                        // Não há mensagem de erro, então os dados foram retornados com sucesso
                        if (response.data.length === 0) {
                            setNenhumaNotificacaoEncontrada(true);
                            setHasMore(false);
                        } else {
                            setNenhumaNotificacaoEncontrada(false);
                            setDados(prevDados => [...prevDados, ...response.data]);
                            if (response.data.length < 15) {
                                setHasMore(false);
                            }
                        }
                    }
                    }).catch(error => {
                        // Trate o erro
                        setLoading(false);
                        alert('Erro ao alterar status da notificação :' + error);
                    });
            }
        });
    };


    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">

                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <Menu page="notificacoes"/>
                </div>
                
                <div className="col py-3 me-3 text-center">
                    <h1>Notificações</h1>
                    {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                    )}
                    <div className={`row ${loading ? 'd-none' : ''}`}></div>

                    <div className="box-notificacao">
                        <table>
                          <thead>
                            <tr>
                                <th>Id./Notificação</th>
                                {/* <th>Id./Reserva</th> */}
                                <th>Descrição</th>
                                <th className="text-right">Data</th>
                                <th></th>
                            </tr>
                          </thead>  
                          <tbody>
                            {
                            dados.map((dados) =>{
                                return<tr key={dados.ID_NOTIFICATION} className={dados.NT_READ === 0 ? 'not-read' : ''}>
                                {/* const trStyle = dados.NT_READ === 0 ? { backgroundColor: '#f9f9f9' } : {};
                                return <tr key={dados.ID_NOTIFICATION} style={trStyle}> */}
                        
                                    <td data-label="id/Notificação.: ">{dados.ID_NOTIFICATION}</td>
                                    {/* <td data-label="Reserva: ">{dados.ID_RESERVA}</td> */}
                                    <td data-label="Descrição: ">{dados.NT_DESCRIPTION}</td>
                                    <td data-label="Data: " className="text-right">{dados.NT_DATA}</td>
                                    <td data-label="Ações:" className="text-right">

                                        {/* **** marcar notificação como não lida **** */}
                                        {dados.NT_READ === 1 && (
                                            <button className="btn btn-success ml-10" onClick={() => handleChangeStatus(dados.ID_NOTIFICATION, dados.NT_READ)}>
                                                <i className="bi bi-check-circle"></i>
                                            </button>
                                        )}
                                        {/* **** ver + detalhes da notificação e outras ações **** */}
                                        {/* <button className="btn btn-info"> */}
                                        <button className="btn btn-info ml-10" onClick={() => handleInfo(
                                            dados.ID_NOTIFICATION,
                                            dados.ID_RESERVA,
                                            dados.NT_TIPO,
                                            dados.NT_DATA,
                                            dados.NT_DESCRIPTION
                                        )}>                                            
                                            <i className="bi bi-info-circle"></i>
                                        </button>

                                        {/* **** marcar notificação como excluída **** */}
                                        <button className="btn btn-danger ml-10" onClick={() => handleExcluir(dados.ID_NOTIFICATION)}>
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            })
                            }
                          </tbody>
                        </table>
                    </div>
                    {hasMore && (
                        <div className="load-more">
                            <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                        </div>
                    )}
                </div>

            </div>
            
        {/* </div> */}
        <Footer />
        </div>
    </>
}

export default Notificacoes;